module.exports = __webpack_public_path__ + "static/media/doors-active.30747dbc.svg";